import { getAlternateDomain } from '@99designs/shared-configuration';

export const get99dDomain = () => {
    return getAlternateDomain(window.location.hostname) ?? '99designs.com';
};
